import React from 'react';

import {
    SearchableSelectType,
    SelectOptionExtended,
} from '../components/inputs/searchableSelect';

import { DetailCellRendererType } from './ag-grid.model';
import { LabelBaseModel, LabelOption } from './label.model';

interface ComponentTypeAdditionalMetadata {
    is_image?: boolean;
    is_editable?: boolean;
    allow_archive: boolean | null;
}
export interface ComponentTypeBase {
    name: string;
    data_key: string;
    base_color: string;
    icon_name: string;
    description?: string;
}
export enum ComponentTypeStatus {
    Live = 'Live',
    Archived = 'Archived',
}
export interface ComponentType extends ComponentTypeBase {
    id: string;
    additional_metadata: ComponentTypeAdditionalMetadata | null;
    created_at?: string;
    archived_at: string | null;
    status: ComponentTypeStatus;
}

export interface ComponentTypeDetail extends ComponentType {
    labels: LabelBaseModel[];
}

export interface ComponentTypeWithLabelOptions extends ComponentType {
    labels: LabelOption[];
}

export interface ComponentTypeCreateRequest extends ComponentTypeBase {
    labels: LabelBaseModel[];
}
export interface ComponentTypeUpdateRequest {
    base_color?: string;
    icon_name?: string;
    description?: string;
}
export interface ComponentTypeMapped extends ComponentType {
    secondary_color: string;
    medium_color: string;
    text_color: string;
}

export interface ComponentTypeMap {
    [key: string]: ComponentTypeMapped;
}

export interface ComponentTypeTransformed {
    list: ComponentTypeMapped[];
    map: ComponentTypeMap;
    selectOptions: SelectOptionExtended[];
    selectOptionsWithAll: SearchableSelectType[];
    allComponentTypes: string[];
    mapById: ComponentTypeMap;
}
export interface Label {
    label: string;
    definition?: string;
    example?: string;
    variantType?: string;
    id: number;
    alternatesCount?: number;
    formulasCount?: number;
    componentType?: string;
    componentTypeId?: string;
    archived_at?: string | null;
}

export interface ComponentTypeGroupedDataModel {
    labelAndComponentName: string;
    labels: Label[];
    count: number;
    createdAt: string | null;
    color: string;
    icon: string;
    dataKey: string;
    name: string;
    description?: string;
    componentId?: string;
    archivedAt: string | null;
    additionalMetadata: ComponentTypeAdditionalMetadata | null;
    status: ComponentTypeStatus;
    allowArchive: boolean;
}

export interface ComponentTypeDetailCellRendererType
    extends DetailCellRendererType<ComponentTypeGroupedDataModel, Label[]> {}

export interface CustomComponentFormValues {
    name: {
        label: string;
        value: string;
        trailingIcon?: React.ReactNode;
    };
    purpose: string;
    labels: {
        name: string;
        description: string;
    }[];
    color: string;
    icon: string;
}

export interface TabularDataModal {
    id: number;
    labelAndComponentName: string;
    example: string;
    description: string;
    variantType: string;
    createdAt: Date;
    count?: number;
    archivedAt?: string | null;
    alternatesCount: number;
    formulasCount: number;
}

export interface ComponentPresetLabelModel {
    id: string;
    name: string;
    description: string;
}
export interface ComponentPresetModel {
    id: string;
    name: string;
    icon_name: string;
    base_color: string;
    description: string;
    labels: ComponentPresetLabelModel[];
}

export enum CustomComponentViewMode {
    Grouped = 'grouped',
    Tabulation = 'tabulation',
}

export enum SortPopupType {
    MostUsed = 'By Most Used',
    LastCreated = 'By Last Created',
    AToZ = 'By A-Z',
    ZToA = 'By Z-A',
}
